module.exports = __webpack_public_path__ + "img/41_37.64445299.png";